<template>
<div :style="$vuetify.breakpoint.mdAndDown ? 'margin-top:55px' : ''">
 
  <v-row no-gutters id="menu-main">
    <v-col
      @click="routerMethod('/pool')"
      :class="$vuetify.breakpoint.lgAndUp ? 'brand' : 'brand-small'"
      md="auto"
    >
      <img class="brand-img"  :src="require('@/assets/img/logo.svg')" />
      
    </v-col>
    <v-col md="auto" class="flex-grow-1"></v-col>
    <v-col md="auto" v-if="$vuetify.breakpoint.lgAndUp" class="my-toolbaritems mb-2" justify="end">
      <div class="menu-main">
        <v-btn @click="routerMethod('/pool')" text class="my-vbtn">
          <span v-bind:class="active === 'Pool' ? 'active':''">TradingPool</span>
        </v-btn>
        <v-btn @click="routerMethod('/journal/'+username)" text class="my-vbtn">
          <span v-bind:class="active === 'Diary' ? 'active':''">Trading Diary</span>
        </v-btn>
        <v-menu
          transition="scale-transition"
          open-on-hover
          close-on-click
          close-on-content-click
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text class="my-vbtn">
              <span v-bind:class="activeMap[active] === 'My Profile' ? 'active':''">
                My Profile
                <v-icon>keyboard_arrow_down</v-icon>
              </span>
            </v-btn>
          </template>
          <v-list class="my-vlist" dense>
            <v-list-item
              class="my-vlistitem"
              v-for="(item, index) in myProfile"
              :key="index"
              @click="routerMethod(item.route)"
            >
              <v-list-item-title class="my-vlistitemtitle">{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="routerMethod('/portfolio')" text class="my-vbtn" disabled>
          <span v-bind:class="active === '/portfolio' ? 'active':''">Portfolio</span>
        </v-btn>
        <v-btn @click="routerMethod('/education')" text class="my-vbtn" disabled>
          <span v-bind:class="active === '/education' ? 'active':''">Education</span>
        </v-btn>
        <v-btn @click="routerMethod('/blog')" text class="my-vbtn" disabled>
          <span v-bind:class="active === '/blog' ? 'active':''">Blog</span>
        </v-btn>
        <ZonePicker v-if="loadTimezone" />
        <v-menu
          v-if="loggedIn"
          transition="scale-transition"
          open-on-hover
          close-on-click
          close-on-content-click
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text class="my-vbtn pr-12">
              <v-icon>keyboard_arrow_down</v-icon>

              <Avatar
                v-if="avatar != null"
                v-bind:class="active === 'Settings' ? 'active-avatar':'border-avatar'"
                :src="avatar"
                :size="40"
              ></Avatar>
              <Avatar
                v-else
                v-bind:class="active === 'Settings' ? 'active-avatar':'border-avatar'"
                :username="username"
                :size="40"
              ></Avatar>
              <div style="position:absolute; top:0; right: 10px">
              <v-badge
                v-if="notifications > 0"
                v-bind:color="1 > 0 ? '#E62163' : '#808F9C'"
                overlap
                class="align-self-center"
              >
                <template v-slot:badge>
                  <span class="my-vbadge">{{notifications}}</span>
                </template>
              </v-badge>
              </div>
            </v-btn>
          </template>
          <v-list class="my-vlist" dense>
            <v-list-item @click="showNotifications = true" class="my-vlistitem">
              <v-list-item-title class="my-vlistitemtitle"><div><div>Notifications</div>
                <div style="position:absolute; top:2px; left: 93px">
                <v-badge
                v-if="notifications > 0"
                v-bind:color="notifications > 0 ? '#E62163' : '#808F9C'"
                overlap
                class="align-self-center"
              >
                <template v-slot:badge>
                  <span class="my-vbadge">{{notifications}}</span>
                </template>
              </v-badge>
                </div>
                </div>
              </v-list-item-title>
            </v-list-item>
           
            <v-list-item @click="routerMethod('/settings')" class="my-vlistitem">
              <v-list-item-title class="my-vlistitemtitle">Settings</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout" class="my-vlistitem">
              <v-list-item-title class="my-vlistitemtitle">Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-col>

    <v-menu v-if="$vuetify.breakpoint.mdAndDown" left bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon size="30px" color="#B6C1CB">menu</v-icon>
        </v-btn>
      </template>

      <v-list class="my-vlist" dense>
        <v-list-item @click="routerMethod('/pool')" class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle"><span v-bind:class="active === 'Pool' ? 'active':''">TradingPool</span></v-list-item-title>
        </v-list-item>
        <v-list-item @click="routerMethod('/journal/'+username)" class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle"><span v-bind:class="active === 'Diary' ? 'active':''">Trading Diary</span></v-list-item-title>
        </v-list-item>
        <v-divider class="mt-1 mb-2" light></v-divider>
        <v-subheader light>My Profile</v-subheader>
        <v-list-item @click="routerMethod('/tags/'+username)" class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle"><span v-bind:class="active === 'tags' ? 'active':''">My Tags</span></v-list-item-title>
        </v-list-item>
        <v-list-item @click="routerMethod('/strategies/'+username)" class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle"><span v-bind:class="active === 'strategies' ? 'active':''">My Strategies</span></v-list-item-title>
        </v-list-item>
        <v-list-item @click="routerMethod('/user/'+username)" class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle"><span v-bind:class="active === 'user' ? 'active':''">Stats</span></v-list-item-title>
        </v-list-item>
        <v-divider class="mt-1 mb-2" light></v-divider>
        <v-list-item  class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle"><span class="disabled">Portfolio</span></v-list-item-title>
        </v-list-item>
        <v-list-item  class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle"><span class="disabled">Education</span></v-list-item-title>
        </v-list-item>
        <v-list-item  class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle"><span class="disabled">Blog</span></v-list-item-title>
        </v-list-item>
        <v-divider class="mt-1 mb-2" light></v-divider>
        <v-subheader light>My Account</v-subheader>
        <v-list-item @click="showNotifications = true" class="my-vlistitem">
              <v-list-item-title class="my-vlistitemtitle"><div><div>Notifications</div>
                <div style="position:absolute; top:2px; left: 93px">
                <v-badge
                v-if="notifications > 0"
                v-bind:color="notifications > 0 ? '#E62163' : '#808F9C'"
                overlap
                class="align-self-center"
              >
                <template v-slot:badge>
                  <span class="my-vbadge">{{notifications}}</span>
                </template>
              </v-badge>
                </div>
                </div>
              </v-list-item-title>
            </v-list-item>
        <v-list-item @click="routerMethod('/settings')" class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle"><span v-bind:class="active === 'Settings' ? 'active':''">Settings</span></v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout" class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle">Logout</v-list-item-title>
        </v-list-item>
        <!--
        <v-list-item class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle">My Portfolio</v-list-item-title>
        </v-list-item>
        <v-list-item class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle">Education</v-list-item-title>
        </v-list-item>
        <v-list-item class="my-vlistitem">
          <v-list-item-title class="my-vlistitemtitle">Blog</v-list-item-title>
        </v-list-item>
        -->
      </v-list>
    </v-menu>
  </v-row>
  <Notifications :show="showNotifications" @close="closeNotifications"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ZonePicker from "./timeZone";
import Notifications from "@/components/notifications";
import Avatar from "vue-avatar";
export default {
  components: {
    Notifications,
    ZonePicker,
    Avatar
  },
  data() {
    return {
      activeMap: {tags: "My Profile", strategies: "My Profile", user: "My Profile"},
      showNotifications: false,
      showMessages: false,
      zones: ["Europe/Prague"],
      loginDialog: false,
      signed: false,
      myProfile: [
        //{ title: "My Info", route: "/strategies" },
        { title: "My Tags", route: "/tags/" + this.$store.getters.username },
        {
          title: "My Strategies",
          route: "/strategies/" + this.$store.getters.username
        },
        { title: "Stats", route: "/user" },
        //{ title: "Followers", route: "/strategies" },
        //{ title: "Blog", route: "/strategies" },
        //{ title: "Video", route: "/strategies" }
      ],
      myAccount: [
        { title: "Settings" },
        { title: "Billing Info" },
        { title: "Withdrawals" },
        { title: "Log Out" }
      ],
      //avatar: null,
      loadTimezone: false
    };
  },
  created() {
    //this.avatar = `http://tradeinpool.com/upload/${this.$store.getters.avatar}.png`
    this.loadTimezone = true;
  },

  computed: {
    ...mapGetters(["notifications"]),

    avatar() {
      if (this.$store.getters.avatar == null) return null;
      else
        return `https://tradeinpool.com/upload/${this.$store.getters.avatar}.png`;
    },

    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    username() {
      return this.$store.getters.username;
    },
    active() {
      return this.$route.name;
    }
  },
  methods: {
    closeNotifications(val){
      this.showNotifications = val
    },
    routerMethod(path) {
      ``;
      this.active = path;
      return this.$router.push({ path: path });
    },
    logout() {
      this.$router.push({
        name: "Logout"
      });
    }
  }
};
</script>

<style scoped>
.disabled{
  color: grey;
  cursor: auto;
}
.my-vbtn {
  font-family: "Roboto", "Roboto Condensed Bold", sans-serif;
  color: #b6c1cb !important;
  text-transform: capitalize !important;
  font-size: 14px !important;
  max-height: 30px !important;
  padding-right: 10px !important;
  padding-left: 10px !important;
}
.my-vbtn:focus {
  outline: none !important;
}
.my-vbtn:hover {
  color: white !important;
}
.my-vlist {
  background-color: #b6c1cb !important;
}
.my-vlistitem {
  cursor: pointer !important;
  max-height: 20px !important;
  height: 20px !important;
}
.my-vlistitemtitle {
  font-size: 14px !important;
  color: #28303d !important;
  max-height: 20px !important;
}
.my-vlistitem:hover > .my-vlistitemtitle {
  color: white !important;
}
.my-vtoolbar {
  background-color: #1e242e !important;
  color: #ffffff !important;
}
.brand {
  margin-left: 30px;
  margin-top: 35px;
  cursor: pointer;
}
.brand-small {
  margin-left: 20px;
  margin-top: 0px;
  padding-bottom: 50px;
  cursor: pointer;
}
.brand-name {
  font-size: 20px;
  font-weight: 100;
}
.brand-img {
  height: 50px;
  margin-bottom: 0px;
}
.menu-main {
  margin-top: 60px;
  padding-right: 8px;
}

.active {
  color: #4dbac0;
  font-weight: bolder;
}
.active-avatar {
  border: 2px solid #4dbac0;
  position: relative;
  top: -4px;
}
.border-avatar {
  border-style: outset;
  border: 2px solid #333b47;
  position: relative;
  top: -4px;
}
</style>